import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EnvironmentService } from '../../environment.service';
import { SharedsService } from 'src/app/shareds/shareds.service';
import { ExceptionHandlerService } from '../../exception-handler.service';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  notification;
  subject = new Subject<any>();
  agentOnlineStatus: any;
  message: any;
  public token;
  private readonly bellMessage = new Subject<any>();
  private readonly chatBox = new Subject<any>();
  private readonly notificationSubject = new Subject<any>();
  notificationSubjectState = this.notificationSubject.asObservable();

  private readonly nplagentMessages = new Subject<any>();
  nplagentMessagesState = this.nplagentMessages.asObservable();

  private readonly toggleSubject = new Subject<any>();
  toggleSubjectState = this.toggleSubject.asObservable();

  public downloadLoader = new BehaviorSubject<boolean>(false);
  downloadLoaderState = this.downloadLoader.asObservable();
  replyStatus: any;
  httpOptions: { headers: HttpHeaders; params: HttpParams };
  apiUrl: any;

  public subsciptionObject = new BehaviorSubject<boolean>(false);
  subscriptionRevoked = this.subsciptionObject.asObservable();
  public readonly readNotificationSubject = new BehaviorSubject<boolean>(false); // Initial count is 0
  readNotification = this.readNotificationSubject.asObservable(); // Observable for subscribers
  constructor(
    private readonly router: Router,
    private readonly envService: EnvironmentService,
    private readonly sharedService: SharedsService,
    private readonly http: HttpClient,
    private readonly expService: ExceptionHandlerService,
  ) {
    const userData = JSON.parse(localStorage.getItem('user'));
    this.token = userData?.token ?? '';
    this.apiUrl = this.envService.read('apiUrl');
  }

  updatedDownloadLoader(data) {
    this.downloadLoader.next(data);
  }

  setNotification(val) {
    this.notification = val;
  }

  getNotification() {
    return this.notification;
  }

  sendMessage(message) {
    this.subject.next(message);
  }
  sendNotificationMessage(message) {
    this.notificationSubject.next(message);
  }

  notificationState(): Observable<any> {
    return this.notificationSubject.asObservable();
  }

  sendNlpAgentMessage(message) {
    this.nplagentMessages.next(message);
  }

  nlpAgentState(): Observable<any> {
    return this.nplagentMessages.asObservable();
  }

  toggleMessage(message) {
    this.toggleSubject.next(message);
  }
  getNotificationMessage() {
    return this.message;
  }

  sendbellMessage(message) {
    this.bellMessage.next(message);
  }
  getbellMessage(): Observable<any> {
    return this.bellMessage.asObservable();
  }

  sendChatBoxMessages(message) {
    this.chatBox.next(message);
  }
  getsendChatBoxMessages(): Observable<any> {
    return this.chatBox.asObservable();
  }

  clearMessage() {
    this.subject.next(null);
  }

  agentStatus(message) {
    this.agentOnlineStatus = message || {};
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  setReplyStatus(val) {
    this.replyStatus = val;
  }

  getReplyStatus() {
    return this.replyStatus;
  }

  updatedSubscriptionWarning(data) {
    this.subsciptionObject.next(data);
  }
  handleTrialExpiry() {
    const userData = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : {};
    const subscriberId =
      userData?.appSettings?.projectDetail?.subscriptionId ?? null;
    const onboardType = userData?.appSettings?.projectDetail?.onboardingType;
    const trialEndDate = new Date(userData?.trail_end_date);
    const now = new Date();
    const trialPeriod = now > trialEndDate;
    if (
      onboardType === 'self-onboard' &&
      !subscriberId &&
      (userData?.trial_expire || (trialEndDate && trialPeriod))
    ) {
      this.router.navigate([environment.dashboardPrefix + '/overviews']);
      return false;
    } else {
      return true;
    }
  }
  getUnreadNotification(arg): Observable<any> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.envService.read('Authorization'),
        'access-token': this.sharedService.token,
      }),
      params: new HttpParams()
        .set('appId', this.sharedService.appId)
        .set('agent_id', arg.agent_id),
    };
    return this.http
      .get<any>(`${this.apiUrl}/unread/message/count`, this.httpOptions)
      .pipe(
        tap(),
        catchError((error) => {
          this.expService.handleError(error);
          return of(error);
        }),
      );
  }
}
